/* eslint-disable no-console */
import axios from "axios";
import { captureAxiosError } from "Services/sentry.service";

import { USER_TOKEN, USER_UID } from "../constants";
import deleteAllTokens from "../util/deleteAllTokens";
import env from "../util/env";

console.log("NODE_DATABASE: ", env.NODE_DATABASE);
console.log("NODE_ENV: ", env.NODE_ENV);

const http = axios.create({
  baseURL: env.API_URL,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem(USER_TOKEN);

  config.headers.Authorization = token || "";

  return config;
});

http.interceptors.response.use(
  (response) => {
    if (response?.status && response?.status === 401) {
      const shouldSignOut = !response?.data?.message?.toLowerCase().includes("session");

      if (shouldSignOut) {
        deleteAllTokens();
        window.location.replace("/signin");
      }
    }

    return response;
  },
  (error) => {
    const originalStackTrace = error.config?.errorContext?.stack;

    if (originalStackTrace) {
      error.stack = `${error.stack}\n${originalStackTrace}`;
    }

    captureAxiosError(error);

    if (error?.response?.status === 401) {
      const shouldSignOut = !error?.response?.data?.message?.toLowerCase().includes("session");

      if (shouldSignOut) {
        deleteAllTokens();
        window.location.replace("/signin");
      }
    }

    throw error;
  }
);

export default http;
